// import React, { useState, useEffect } from "react";
// import { useWallet } from "../context/walletContext";
// import { MdClose } from "react-icons/md";
// import { useNotify } from "../context/NotifyContext";
// import { TextField, CircularProgress } from "@mui/material";
// import { formatAmount } from "../utils/formatAmount";

// const ServicesForm = ({ bill, onSubmit, close, loading }) => {
//   const [amount, setAmount] = useState(bill?.amount || "");
//   const { walletAmt } = useWallet();
//   const [amountError, setAmountError] = useState("");

//   const { notify } = useNotify();

//   const walletBalance = Number(walletAmt?.main?.balance || 0);
//   const billAmount = Number(bill?.amount || 0);

//   const handlePayClick = () => {
//     setAmountError("");
//     if (!amount) {
//       setAmountError("Amount is required");
//       return notify("Amount is required", "error");
//     }

//     const finalAmount = Number(amount);

//     if (isNaN(finalAmount)) {
//       setAmountError("Invalid amount");
//       return notify("Please enter a valid number", "error");
//     }

//     if (finalAmount <= 0) {
//       setAmountError("Amount must be greater than zero");
//       return notify("Amount must be greater than zero", "error");
//     }

//     if (finalAmount > billAmount) {
//       setAmountError("Amount exceeds bill amount");
//       return notify(`Amount cannot exceed bill amount ₹${billAmount}`, "error");
//     }

//     if (finalAmount > walletBalance) {
//       setAmountError("Insufficient wallet balance");
//       return notify(`Amount cannot exceed wallet balance ₹${walletBalance}`, "error");
//     }

//     onSubmit({
//       amount: finalAmount,
//       originalAmount: bill?.amount,
//       ad2: bill?.ad2,
//       ad3: bill?.ad3,
//       name: bill?.name,
//       duedate: bill?.duedate,
//       bill_fetch: bill?.bill_fetch,
//     });
//   };

//   const handleInputChange = (e) => {
//     let val = e.target.value;

//     if (!/^[0-9]*$/.test(val)) return;

//     const maxAllowed = Math.min(walletBalance, billAmount);

//     if (Number(val) > maxAllowed) {
//       notify(`Maximum allowed amount ₹${formatAmount(maxAllowed)}`, "info");
//       return setAmount(maxAllowed);
//     }

//     setAmount(val);
//   };

//   useEffect(() => {
//     if (!amountError) return;

//     const timer = setTimeout(() => {
//       setAmountError("");
//     }, 3000);

//     return () => clearTimeout(timer);
//   }, [amountError]);

//   useEffect(() => {
//     setAmount(bill?.amount || "");
//   }, [bill]);

//   return (
//     <div className="ds-card p-3 sm:p-4 w-full max-w-sm">
//       <div className="flex items-start justify-between mb-3">
//         <h2 className="text-[15px] font-semibold text-[var(--text-dark)]">Bill Details</h2>
//         <MdClose
//           className="cursor-pointer text-[var(--text-muted)] hover:text-[var(--error-color)]"
//           onClick={close}
//           size={20}
//         />
//       </div>

//       <div className="space-y-3">
//         <div className="grid grid-cols-2 border-b border-[var(--border-color)] pb-2 text-[13px]">
//           <span className="font-medium text-[var(--text-muted)]">Customer Name:</span>
//           <span className="font-semibold text-[var(--text-dark)]">{bill?.name || "N/A"}</span>
//         </div>

//         <div className="grid grid-cols-2 border-b border-[var(--border-color)] pb-2 text-[13px]">
//           <span className="font-medium text-[var(--text-muted)]">Bill Amount:</span>
//           <span className="font-semibold text-[var(--error-color)]">
//             ₹ {formatAmount(billAmount)}
//           </span>
//         </div>

//         <div className="grid grid-cols-2 border-b border-[var(--border-color)] pb-2 text-[13px]">
//           <span className="font-medium text-[var(--text-muted)]">Wallet Balance:</span>
//           <span className="font-semibold text-[var(--text-dark)]">
//             ₹ {formatAmount(walletBalance)}
//           </span>
//         </div>

//         <div className="grid grid-cols-2 border-b border-[var(--border-color)] pb-2 text-[13px]">
//           <span className="font-medium text-[var(--text-muted)]">Due Date:</span>
//           <span className="font-semibold text-[var(--text-dark)]">{bill?.duedate || "N/A"}</span>
//         </div>

//         {bill?.ad2 && (
//           <div className="grid grid-cols-2 border-b border-[var(--border-color)] pb-2 text-[13px]">
//             <span className="font-medium text-[var(--text-muted)]">AD2:</span>
//             <span className="font-semibold text-[var(--text-dark)]">{bill.ad2}</span>
//           </div>
//         )}

//         {bill?.ad3 && (
//           <div className="grid grid-cols-2 border-b border-[var(--border-color)] pb-2 text-[13px]">
//             <span className="font-medium text-[var(--text-muted)]">AD3:</span>
//             <span className="font-semibold text-[var(--text-dark)]">{bill.ad3}</span>
//           </div>
//         )}

//         <div className="mt-3">
//           <TextField
//             fullWidth
//             size="small"
//             label="Enter Amount"
//             value={amount}
//             onChange={handleInputChange}
//             error={Boolean(amountError)}
//           />

//           <button
//             type="button"
//             onClick={handlePayClick}
//             disabled={loading}
//             className="ds-btn ds-btn-primary ds-btn-block mt-4"
//           >
//             {loading ? <CircularProgress size={22} thickness={5} color="inherit" /> : "Pay Bill"}
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default ServicesForm;



import React, { useState, useEffect } from "react";
import { useWallet } from "../context/walletContext";
import { MdClose } from "react-icons/md";
import { useNotify } from "../context/NotifyContext";
import { TextField, CircularProgress } from "@mui/material";
import { formatAmount } from "../utils/formatAmount";

const Row = ({ label, value, valueClass = "text-[var(--text-dark)]" }) => (
  <div className="grid grid-cols-2 border-b border-[var(--border-color)] pb-2 text-[13px] gap-2">
    <span className="font-medium text-[var(--text-muted)]">{label}:</span>
    <span className={`font-semibold break-all ${valueClass}`}>{value}</span>
  </div>
);

const ServicesForm = ({ bill, onSubmit, close, loading }) => {
  // Credit card bill me Wingpay ka referenceNumber hota hai
  const isCreditCard = Boolean(bill?.referenceNumber);

  const [amount, setAmount] = useState(bill?.amount ? String(bill.amount) : "");
  const { walletAmt } = useWallet();
  const [amountError, setAmountError] = useState("");

  const { notify } = useNotify();

  // const walletBalance = Number(walletAmt?.main?.balance || 0);
  const walletBalance = Number(walletAmt?.addMoney?.balance || 0);
  const billAmount = Number(bill?.amount || 0);

  const handlePayClick = () => {
    setAmountError("");
    if (!amount) {
      setAmountError("Amount is required");
      return notify("Amount is required", "error");
    }

    const finalAmount = Number(amount);

    if (isNaN(finalAmount)) {
      setAmountError("Invalid amount");
      return notify("Please enter a valid number", "error");
    }

    if (finalAmount <= 0) {
      setAmountError("Amount must be greater than zero");
      return notify("Amount must be greater than zero", "error");
    }

    if (finalAmount > billAmount) {
      setAmountError("Amount exceeds bill amount");
      return notify(`Amount cannot exceed bill amount ₹${formatAmount(billAmount)}`, "error");
    }

    if (finalAmount > walletBalance) {
      setAmountError("Insufficient wallet balance");
      return notify(`Amount cannot exceed wallet balance ₹${formatAmount(walletBalance)}`, "error");
    }

    onSubmit({
      amount: finalAmount,
      originalAmount: bill?.amount,
      ad2: bill?.ad2,
      ad3: bill?.ad3,
      name: bill?.name,
      duedate: bill?.duedate,
      bill_fetch: bill?.bill_fetch,
      referenceNumber: bill?.referenceNumber,
    });
  };

  const handleInputChange = (e) => {
    const val = e.target.value;

    // Credit card me paise (2 decimals) allowed, baaki bills me sirf integer
    const pattern = isCreditCard ? /^\d*\.?\d{0,2}$/ : /^[0-9]*$/;
    if (!pattern.test(val)) return;

    const maxAllowed = Math.floor(Math.min(walletBalance, billAmount) * 100) / 100;

    if (Number(val) > maxAllowed) {
      notify(`Maximum allowed amount ₹${formatAmount(maxAllowed)}`, "info");
      return setAmount(String(maxAllowed));
    }

    setAmount(val);
  };

  useEffect(() => {
    if (!amountError) return;

    const timer = setTimeout(() => {
      setAmountError("");
    }, 3000);

    return () => clearTimeout(timer);
  }, [amountError]);

  useEffect(() => {
    setAmount(bill?.amount ? String(bill.amount) : "");
  }, [bill]);

  return (
    <div className="ds-card p-3 sm:p-4 w-full max-w-sm">
      <div className="flex items-start justify-between mb-3">
        <h2 className="text-[15px] font-semibold text-[var(--text-dark)]">Bill Details</h2>
        <MdClose
          className="cursor-pointer text-[var(--text-muted)] hover:text-[var(--error-color)]"
          onClick={close}
          size={20}
        />
      </div>

      <div className="space-y-3">
        <Row label="Customer Name" value={bill?.name || "N/A"} />

        {isCreditCard && bill?.cardLast4 && (
          <Row label="Card Number" value={`XXXX XXXX XXXX ${bill.cardLast4}`} />
        )}

        <Row
          label="Bill Amount"
          value={`₹ ${formatAmount(billAmount)}`}
          valueClass="text-[var(--error-color)]"
        />

        <Row label="Wallet Balance" value={`₹ ${formatAmount(walletBalance)}`} />

        {isCreditCard && <Row label="Bill Date" value={bill?.billDate || "N/A"} />}

        <Row label="Due Date" value={bill?.duedate || "N/A"} />

        {isCreditCard && bill?.billNumber && <Row label="Bill Number" value={bill.billNumber} />}

        {isCreditCard && <Row label="Reference No." value={bill.referenceNumber} />}

        {/* biller-specific additionalInfo (khali ho sakta hai) */}
        {isCreditCard &&
          (bill?.additionalInfo || []).map((info, i) => (
            <Row key={i} label={info?.infoName || "Info"} value={info?.infoValue || "--"} />
          ))}

        {!isCreditCard && bill?.ad2 && <Row label="AD2" value={bill.ad2} />}
        {!isCreditCard && bill?.ad3 && <Row label="AD3" value={bill.ad3} />}

        <div className="mt-3">
          <TextField
            fullWidth
            size="small"
            label="Enter Amount"
            value={amount}
            onChange={handleInputChange}
            error={Boolean(amountError)}
            helperText={amountError || (isCreditCard ? "Partial payment allowed" : "")}
            inputProps={{ inputMode: isCreditCard ? "decimal" : "numeric" }}
          />

          <button
            type="button"
            onClick={handlePayClick}
            disabled={loading}
            className="ds-btn ds-btn-primary ds-btn-block mt-4"
          >
            {loading ? <CircularProgress size={22} thickness={5} color="inherit" /> : "Pay Bill"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ServicesForm;